export default __webpack_public_path__ + "img/bootstrap.15417f61.jpg";